import { PageBreadcrumbItem } from "components/common/PageBreadcrumb";

export type EmpresaType = {
  id: string;
  codigo: number;
  nomeFantasia: string;
  localDeTrabalho: boolean;
  cnpj: string;
  serieNFe?: number;
  homologacao: boolean;
  endereco: {
    logradouro: string;
    numero: string;
    complemento?: string;
    bairro: string;
    cep: string;
    municipio: string;
    uf: string;
  }
};

export type EmpresaQueryType = {
  itens: EmpresaType[];
  total: number;
};

export type EmpresaTableType = {
  id: number | undefined;
  codigo: number | undefined;
  nomeFantasia: string;
  razaoSocial: string;
  cnpj: string;
  inscricaoEstadual: string;
  regimeTributario: number;
};

export type EnderecoDtoType = {
  descricao: string;
  cep: string;
  logradouro: string;
  complemento?: string;
  bairro: string;
  municipio: string;
  uf: string;
  ibge: string;
  numero: string;
};

export const regimesTributarios = [
  { value: 0, label: "Simples Nacional" },
  { value: 1, label: "Simples Nacional c/ Sublimite" },
  { value: 2, label: "Lucro Presumido" },
  { value: 3, label: "Lucro Real" },
];

export type CriarEmpresaDtoType = {
  nomeFantasia: string;
  razaoSocial: string;
  cnpj: string;
  inscricaoEstadual: string;
  telefone: string;
  email: string;
  responsavel: string;
  regimeTributario: string;
  endereco: EnderecoDtoType;
  certificado?: {
    senha: string;
    arquivo: string;
  };
};

export type AlterarEmpresaDtoType = {
  codigo: number;
  nomeFantasia: string;
  razaoSocial: string;
  cnpj: string;
  inscricaoEstadual: string;
  telefone: string;
  email: string;
  responsavel: string;
  regimeTributario: string;
  endereco: EnderecoDtoType;
  responsavelTecnicoId?: string;
};

export const empresasBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: "Cadastros",
    url: "#!",
  },
  {
    label: "Empresas",
    active: true,
  },
];

export const empresaBreadcrumbItems = (
  codigo?: number
): PageBreadcrumbItem[] => [
  {
    label: "Cadastros",
    url: "#!",
  },
  {
    label: "Empresas",
    url: "/cadastros/empresas",
  },
  {
    label: codigo?.toString() ?? "Nova",
    active: true,
  },
];
